import React from "react";

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    {...other}
    style={{ width: "100%" }}
  >
    {value === index && <div>{children}</div>}
  </div>
);

export default TabPanel;
